export function scrollTop() {
    let scrollTopBtn = document.getElementById("scrollTopBtn");
    let timer;

    if (scrollTopBtn) {
        window.addEventListener('scroll', scrollFunction)

        function show() {
            scrollTopBtn.hidden=false;
            timer = setTimeout(hide,2000);
        }

        function hide() {
            scrollTopBtn.hidden=true;
        }

        function scrollFunction() {
            if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
                clearTimeout(timer);
                show();
            } else {
                hide();
            }
        }

        function topFunction() {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }

        scrollTopBtn.addEventListener('click', topFunction)
    }
}